import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../Sidebar/Sidebar';
import Topbar from '../Topbar/Topbar';
import './ComingSoon.css';

const ComingSoon = ({ title, description, icon, activeId }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [theme, setTheme] = useState(localStorage.getItem('projabze_theme') || 'dark');

  useEffect(() => {
    const stored = localStorage.getItem('projabze_user');
    if (stored) setUser(JSON.parse(stored));
    else navigate('/');
  }, [navigate]);

  if (!user) return null;

  return (
    <div className={`coming-soon-page ${theme}`}>
      <Topbar user={user} theme={theme} onToggleTheme={() => setTheme(t => { const n = t === 'dark' ? 'light' : 'dark'; localStorage.setItem('projabze_theme', n); return n; })} />
      <div className="coming-soon-layout">
        <Sidebar activeId={activeId} user={user} onLogout={() => { localStorage.clear(); navigate('/'); }} />
        <main className="coming-soon-main">
          <div className="coming-soon-card">
            <div className="coming-soon-icon">{icon}</div>
            <h1 className="coming-soon-title">{title}</h1>
            <p className="coming-soon-desc">{description}</p>
            <div className="coming-soon-badge">Gelistirme Asamasinda</div>
            <p className="coming-soon-hint">Bu ozellik uzerinde calisiyoruz. Cok yakinda burada olacak!</p>
          </div>
        </main>
      </div>
    </div>
  );
};

export default ComingSoon;
